import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { SxProps, Theme, useTheme } from '@mui/material/styles'
import { ReactElement, ReactNode } from 'react'

// We need to use `lodash.get` to access a second-level property of `theme.palette`
// e.g. given "primary.dark" we need to access `theme.palette.primary.dark`
// eslint-disable-next-line no-restricted-imports
import { get } from 'lodash-es'

export type IconProps = {
    svgIcon?: string | ReactNode
    color?: string // TODO: create type for color selectors e.g: 'primary.dark'
    small?: boolean
    sx?: SxProps<Theme>
} & Omit<SvgIconProps, 'color' | 'sx'>

/**
 * Create an Icon component with a specific SVG
 * For use only within the DS—do not export out of the DS
 */
export default function createIcon(svgIcon: IconProps['svgIcon']): (props: IconProps) => ReactElement<IconProps> {
    return function IconCreator({ color = '', small, sx, className }: IconProps): ReactElement<IconProps> {
        const theme = useTheme()
        const themeColor: string = get(theme.palette, color, 'inherit')

        return (
            <SvgIcon htmlColor={themeColor} fontSize={small ? 'small' : 'medium'} sx={sx} className={className}>
                {typeof svgIcon === 'string' ? <path d={svgIcon} /> : svgIcon}
            </SvgIcon>
        )
    }
}

export type IconType = ReturnType<typeof createIcon>
